import { render } from "./ContinuePlayComponent.vue?vue&type=template&id=13eb4481"
import script from "./ContinuePlayComponent.vue?vue&type=script&lang=ts"
export * from "./ContinuePlayComponent.vue?vue&type=script&lang=ts"
script.render = render

export default script